
$(function () {
    window.configureProductSelectCarousels();
    window.configureAnimatedEgiftPreview();
});

window.configureProductSelectCarousels = function () {
    let sliders = document.querySelectorAll('.glide:not(.glide--slider)');
    window.glides = [];

    for (let i = 0; i < sliders.length; i++) {
        let $glide = new Glide(sliders[i], window.options.glideOptions);
        window.glides.push($glide);

        $glide.on('mount.after', function () {
            let $carousel = $($glide.selector);
            selectCarouselItem($carousel);
        });

        $glide.on('run.after', function () {
            let $carousel = $($glide.selector);
            let productId = $carousel.find('.' + $glide.settings.classes.activeSlide).data('product-id');
            selectCarouselItem($carousel, productId);

            if ($glide.selector.id === 'containerCardCarousel' && $("#carouselForcedWalletGroupSettings").length) {

                $.post($('#carouselForcedWalletGroupSettings').data('post-url'), { giftCardProductId: productId }, function (html) {
                    $('#containerWalletCarousel').replaceWith(html);
                    window.configureProductSelectCarousels();
                    window.configureAnimatedEgiftPreview();
                });
            }
        });

        $($glide.selector).on('click', '[data-product-id]', function () {
            let $carousel = $($glide.selector);
            let noneClones = $carousel.find('.glide__slide').not('.glide__slide--clone');
            let clickedIndex = noneClones.index($(this));
            if (clickedIndex == -1) {
                clickedIndex = 0;
            }
            $glide.go('=' + clickedIndex);
        });

        $glide.mount();
    }
}

function selectCarouselItem($carousel, productId) {
    const $productIdField = $carousel.closest('.carousel-container').find('.selected-product-id');

    if (productId === undefined) {
        productId = $productIdField.val();
    } else {
        $productIdField.val(productId);
        $(document).trigger('product-selected');
    }
}
